<template>
	<search-list ref="sl" :where="where" api-path="/camp/list" notSearchAll :searchKeys="searchKeys">
		<mm-lc title="Channel">
			<mm-channel-select no_paused v-model="where.networkid" multiple />
		</mm-lc>
		<mm-lc title="Change">
			<el-switch v-model="change_components" @change="changeComponents"/>
		</mm-lc>
		<mm-lc title="Nice">
			<el-switch v-model="where.nice" v-if="!change_components"></el-switch>
			<mm-tf-select v-model="where.nice" v-if="change_components"/>
		</mm-lc>
		<mm-lc title="White">
			<el-switch v-model="where.white" v-if="!change_components"></el-switch>
			<mm-tf-select v-model="where.white" v-if="change_components"/>
		</mm-lc>
		<mm-lc title="Block">
			<el-switch v-model="where.block_click" v-if="!change_components"></el-switch>
			<mm-tf-select v-model="where.block_click" v-if="change_components"/>
		</mm-lc>
		<mm-lc title="Adv">
			<mm-adv-select no_paused v-model="where.adv_id" multiple />
		</mm-lc>
		<mm-lc title="Offer.Status">
			<mm-offer-status v-model="where.status" multiple />
		</mm-lc>
		<mm-lc title="Offer.Manual Status">
			<mm-offer-status v-model="where.manual_status" multiple />
		</mm-lc>
		<mm-lc title="Platform">
			<mm-offer-platform v-model="where.platform" multiple />
		</mm-lc>

		<el-dropdown size="mini" trigger="click" slot="statusAction">
			<el-button size="small" type="primary">
				<i class="el-icon-edit"></i>Batch Op
			</el-button>
			<el-dropdown-menu slot="dropdown">
				<el-dropdown-item  @click.native="batchEdit({white:true})">White</el-dropdown-item>
				<el-dropdown-item  @click.native="batchEdit({white:false})">Cancel White</el-dropdown-item>
				<el-dropdown-item @click.native="batchEdit({block:true})">Block</el-dropdown-item>
				<el-dropdown-item @click.native="batchEdit({block:false})">Cancel Block</el-dropdown-item>
				<el-dropdown-item @click.native="batchEditSubs()">Edit Subs</el-dropdown-item>
				<el-dropdown-item @click.native="batchEditInfo()">Edit Info</el-dropdown-item>
			</el-dropdown-menu>
		</el-dropdown>

		<mm-table slot="dataTable" slot-scope="res" :res="res" @selection-change="selectionChange">
			<template slot-scope="etc">
			<el-table-column type="selection" fixed :selectable="selectable" />
			<el-table-column label="Offer Id" prop="offer_id" min-width="150" :renderHeader="etc.renderHeaderCopy" fixed>
				<mm-get-detail slot-scope="sp" row_type="offer" :row_id="sp.row.offer_id" :row_name="sp.row.offer_id" />
			</el-table-column>
			<el-table-column label="Offer Name" prop="offer_name" min-width="150" fixed :renderHeader="etc.renderHeaderCopyNew('\r')" />
			<el-table-column label="Channel" width="100" prop="network" fixed>
				<mm-get-detail slot-scope="sp" :row_id="sp.row.networkid" :row_name="sp.row.network" :row_type="'channel'"/>
			</el-table-column>
			<el-table-column label="Channel Id" prop="networkid" min-width="100"/>
			<el-table-column label="Adv" prop="adv">
				<mm-get-detail slot-scope="sp" :row_name="sp.row.adv" :row_id="sp.row.adv_id" row_type="adv" />
			</el-table-column>
			<el-table-column label="Platform" prop="platform" />
			<el-table-column width="98" label="Payout" prop="camp_price">
				<span slot-scope="sp">{{sp.row.offer_price}} | {{sp.row.camp_price}}</span>
			</el-table-column>
			<el-table-column label="Nice" prop="nice" width="55">
				<span slot-scope="sp">{{sp.row.nice?'Nice':''}}</span>
			</el-table-column>
			<el-table-column label="Block"  min-width="100">
				<template slot-scope="sp">
				<span  v-if="sp.row.block_click&&sp.row.block_conv">Block All</span>
				<span  v-else-if="sp.row.block_click">Block Click</span>
				<span  v-else-if="sp.row.block_conv">Block Conver</span>
				</template>
			</el-table-column>
			<el-table-column label="Block Reason" prop="block_reason" width="76" />
			<el-table-column label="Daily Cap" prop="daily_cap" width="60" />
			<el-table-column label="Click Cap" prop="click_cap" width="60" />
			<el-table-column label="White" prop="white" width="65">
				<span slot-scope="sp">{{sp.row.white?'White':''}}</span>
			</el-table-column>
			<el-table-column label="Time" prop="update_at" min-width="140">
				<span slot-scope="sp">{{timeFormat(sp.row.update_at)}}</span>
			</el-table-column>
			<el-table-column label="Status" prop="status" fixed="right">
				<span slot-scope="sp" :class="'status-'+sp.row.status">{{sp.row.status&&sp.row.status.toUpperCase()}}</span>
			</el-table-column>
			<el-table-column label="Manual Status" prop="manual_status" fixed="right" width="85">
				<span slot-scope="sp" :class="'status-'+sp.row.manual_status">{{sp.row.manual_status&&sp.row.manual_status.toUpperCase()}}</span>
			</el-table-column>
			<el-table-column label="Actions" fixed="right">
				<el-button :disabled="!sp.row.manual" slot-scope="sp" @click.native="edit(sp.row)" >Edit</el-button>
			</el-table-column>
			</template>
		</mm-table>
		<el-dialog :visible.sync="showEditSubs">
			<span slot="title">Edit Subs</span>
			<mm-channel-subs v-model='subs'></mm-channel-subs>
			<el-button type="primary" style="margin-left:150px;" @click='updateSubs()'>Save</el-button>
		</el-dialog>
		<el-dialog :visible.sync="showEditInfo">
			<span slot="title">Edit Info</span>
			<el-form ref="form" :model="info" size="small" label-width="200px">
				<el-form-item label="Daily Cap" >
					<el-input type="number" @mousewheel.native.prevent v-model="info.daily_cap"/>
				</el-form-item>
				<el-form-item label="No Block Conv" >
					<el-switch :active-value="1" v-model="info.no_block_conv"/>
				</el-form-item>
				<el-form-item label="Click Cap" >
						<el-input type="number" v-model="info.click_cap"/>
				</el-form-item>
				<el-form-item label="Payout Rate(%)"  >
					<mm-input-number-percent v-model="info.price_percent" />
				</el-form-item>
				<el-form-item label="Deduction Rate(%)"  >
					<mm-input-number-percent v-model="info.def" limit_min="-3"/>
				</el-form-item>
				<el-form-item label="White" >
					<el-switch v-model="info.white" />
				</el-form-item>
				<el-form-item label="Block Click" >
					<el-switch :active-value="1" v-model="info.block_click" />
				</el-form-item>
				<el-form-item label="Block Conver" >
					<el-switch :active-value="1" v-model="info.block_conv" />
				</el-form-item>
				<el-form-item label="Block Reason" >
					<el-input type="textarea" rows="3" v-model="info.block_reason" />
				</el-form-item>
			</el-form>
		<el-button type="primary" style="margin-left:150px;" @click='updateInfo()'>Save</el-button>
		</el-dialog>
	</search-list>
</template>

<script>
export default {
	data() {
		const searchKeys = {
			offer_id: { label: "Offer Id" },
			adv_offer_id: { label: "Adv Offer Id" },
			package_id: { label: "Package Id", fuzzy: true },
		};
		return {
			where: {},
			searchKeys,
			selected: [],
			showEditSubs: false,
			showEditInfo: false,
			subs:{},
			info:{},
			networkids:[],
			change_components: false
		};
	},
	methods: {
		timeFormat(date) {
			date = new Date(date);
			return this.$utils.date_format(date, "YYYY-MM-DD hh:mm:ss");
		},
		selectionChange(v) {
			this.selected = v.map(v => v["_id"]);
			this.networkids = v.map(v => v["networkid"]);
		},
		selectable(row, index) {
			return row.manual;
		},
		async batchEdit(body) {
			await this.$post("/camp/batchEdit", 
				Object.assign(body,{
					_ids: this.selected,
				}));
			this.$refs.sl.refresh();
			this.$refs.dataTable.$el.$refs.mm_table.clearSelection();
			this.selected = [];
		},
		edit(row) {
			window.open(`/campEdit?offer_id=${row.offer_id}&networkid=${row.networkid}`);
		},
		batchEditSubs() {
			const networkid_arr = this.$utils._.uniq(this.networkids);
			if (networkid_arr.length !== 1) {
				this.$message({
					type: 'error',
					message: 'different channel',
				})
				return;
			}
			this.showEditSubs = true;
		},
		batchEditInfo() {
			this.showEditInfo = true;
		},
		async updateSubs() {
			this.showEditSubs = false;
			await this.$post("/camp/batchEdit", { subs: this.subs, _ids: this.selected });
			this.$refs.sl.refresh();
			this.$refs.dataTable.$el.$refs.mm_table.clearSelection();
			this.selected = [];
		},
		async updateInfo() {
			this.showEditInfo = false;
			this.info._ids = this.selected;
			await this.$post("/camp/batchEdit", this.info);
			this.$refs.sl.refresh();
			this.$refs.dataTable.$el.$refs.mm_table.clearSelection();
			this.selected = [];
		},
		changeComponents() {
			delete this.where.nice;
			delete this.where.white;
			delete this.where.block_click;
		}
	}
};
</script>

<style scoped>
</style>


